<template>
  <div class="entry-content">
    <div class="row">
      <div class="col-md-12">
        <div class="entry-header-admin">
          <div class="gap-40"></div>
          <div class="col-md-12 entry-title-admin">
            <div class="row">
              <div class="col-md-8">
                <p class="font-120P">Edit Agent License</p>
              </div>
              <div class="col-md-4 text-right">
                <router-link
                  :to="{ name: 'agent_licenses' }"
                  class="btn btn-secondary"
                >
                  <i class="fa fa-arrow-left"></i> Back to List
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gap-40"></div>

    <!-- Loading Spinner -->
    <div v-if="isLoading" class="text-center">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <p>Loading agent license...</p>
    </div>

    <!-- Form Section -->
    <div v-else class="row">
      <div class="col-md-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Agent License Details</h3>
          </div>
          <div class="panel-body">
            <form @submit.prevent="handleSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">Agent Name *</label>
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      v-model="formData.name"
                      :class="{ 'has-error': errors.name }"
                      placeholder="e.g., WA – Nikki Katz"
                      required
                    />
                    <span v-if="errors.name" class="help-block text-danger">
                      {{ errors.name[0] }}
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="line_one">License Number *</label>
                    <input
                      type="text"
                      class="form-control"
                      id="line_one"
                      v-model="formData.line_one"
                      :class="{ 'has-error': errors.line_one }"
                      placeholder="e.g., Licence TC63625 - RA60387"
                      required
                    />
                    <span v-if="errors.line_one" class="help-block text-danger">
                      {{ errors.line_one[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="path">Path</label>
                    <input
                      type="text"
                      class="form-control"
                      id="path"
                      v-model="formData.path"
                      :class="{ 'has-error': errors.path }"
                      placeholder="e.g., /agents/9d69d8da-2b38-4848-8d91-05ec1b6aed20"
                    />
                    <span v-if="errors.path" class="help-block text-danger">
                      {{ errors.path[0] }}
                    </span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="order_number">Order Number</label>
                    <input
                      type="text"
                      class="form-control"
                      id="order_number"
                      v-model="formData.order_number"
                      :class="{ 'has-error': errors.order_number }"
                      placeholder="e.g., 1, 2, 3, etc."
                    />
                    <span v-if="errors.order_number" class="help-block text-danger">
                      {{ errors.order_number[0] }}
                    </span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="base">Base</label>
                    <input
                      type="text"
                      class="form-control"
                      id="base"
                      v-model="formData.base"
                      :class="{ 'has-error': errors.base }"
                      placeholder="e.g., [WEB]"
                    />
                    <span v-if="errors.base" class="help-block text-danger">
                      {{ errors.base[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <button
                      type="submit"
                      class="btn btn-danger"
                      :disabled="isSubmitting"
                    >
                      <span v-if="isSubmitting">
                        <i class="fa fa-spinner fa-spin"></i> Updating...
                      </span>
                      <span v-else>
                        <i class="fa fa-save"></i> Update Agent License
                      </span>
                    </button>
                    <router-link
                      :to="{ name: 'agent_licenses' }"
                      class="btn btn-danger ml-2"
                      :disabled="isSubmitting"
                    >
                      Cancel
                    </router-link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { configs } from "@/lib/axios";
export default {
  name: 'AgentLicenseEdit',
  data() {
    return {
      formData: {
        name: '',
        line_one: '',
        order_number: '',
        path: '',
        base: '',
      },
      errors: {},
      isSubmitting: false,
      isLoading: true
    };
  },
  mounted() {
    this.setupBreadcrumbs();
    this.loadAgentLicense();
  },
  methods: {
    setupBreadcrumbs() {
      this.$store.commit("app/SET_BREADCRUMBS", [
        {
          name: "Dashboard",
          url: "home"
        },
        {
          name: "Admin",
          url: "admin_users"
        },
        {
          name: "Agent Licenses",
          url: "agent_licenses"
        },
        {
          name: "Edit",
          url: null,
          active: true
        }
      ]);
    },
    
    async loadAgentLicense() {
      try {
        const response = await configs.get(
          `/admin/agent-licenses/${this.$route.params.id}`
        );
        
        this.formData = { ...response.data };
      } catch (error) {
        console.error('Error loading agent license:', error);
        this.$toast.error('Error loading agent license');
        this.$router.push({ name: 'agent_licenses' });
      } finally {
        this.isLoading = false;
      }
    },
    
    async handleSubmit() {
      this.isSubmitting = true;
      this.errors = {};
      
      try {
        await configs.put(
          `/admin/agent-licenses/${this.$route.params.id}`,
          this.formData
        );
        
        // this.$toast.success('Agent license updated successfully');
        this.$router.push({ name: 'agent_licenses' });
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          this.errors = error.response.data.errors;
        } else {
          console.error('Error updating agent license:', error);
          this.$toast.error('Error updating agent license');
        }
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style scoped>
.entry-header-admin {
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 20px;
}

.entry-title-admin {
  margin-bottom: 0;
}

.panel {
  border: 1px solid #ddd;
  border-radius: 5px;
}

.panel-heading {
  background-color: #f8f9fa;
  border-bottom: 1px solid #ddd;
  padding: 10px 15px;
}

.panel-title {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

.panel-body {
  padding: 15px;
}

.has-error {
  border-color: #dc3545;
}

.help-block {
  font-size: 12px;
  margin-top: 5px;
}

.ml-2 {
  margin-left: 10px;
}
</style> 